import { render, staticRenderFns } from "./activation-policy.vue?vue&type=template&id=56312a05&"
import script from "./activation-policy.vue?vue&type=script&lang=js&"
export * from "./activation-policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports